$(document).ready( () => {

    let drawerHeight, threshold, hammer;

    // Função para abrir o drawer dinamicamente
    function openDrawer(modalId) {

      const $drawer = $(`#${modalId}`);
      drawerHeight = $drawer.outerHeight();
      threshold = drawerHeight * 0.4; // Fechar se arrastar mais que 40% 
  
      // Configurações do Hammer.js para o drawer específico
      hammer = new Hammer($drawer[0]);
      hammer.get('pan').set({ direction: Hammer.DIRECTION_VERTICAL });
  
      // Definir ações de arraste apenas para o drawer atual
      hammer.on('pan', function(e) {
        if ($drawer.hasClass('open') && e.direction === Hammer.DIRECTION_DOWN) {
          const moveY = Math.max(0, e.deltaY);
          $drawer.css('bottom', `-${moveY}px`);
        }
      });
  
      hammer.on('panend', function(e) {
        if ($drawer.hasClass('open') && e.direction === Hammer.DIRECTION_DOWN) { 
          const moveY = e.deltaY;
          moveY > threshold ? closeDrawer($drawer) : $drawer.css('bottom', '0');
        }
      });
  
      // Abrir o drawer
      $drawer.addClass('open').css('bottom', '0');
      $('.mobile-filters-overlay').addClass('active');
    }
    
    // Função para fechar o drawer
    function closeDrawer() {
      $('.mobile-overlay-content').removeClass('open').css('bottom', '');
      hammer.off('pan panend'); // Desativar eventos ao fechar
      $('.mobile-filters-overlay').removeClass('active');
    }
  
    // Evento de clique nos botões com a classe .btn-toggle-filter
    $('.btn-toggle-filter').click(function() {
      const modalId = $(this).attr('modal'); // Pegar o ID do drawer dinamicamente
      openDrawer(modalId);
    });
    
    // Evento para fechar o drawer quando clicado no overlay do modal
    $('.mobile-filters-overlay .overlay-bg').click(function() {
        closeDrawer();
    });

    // Evento para fechar o drawer quando clicado no botão de fechar
    $('.drawer .drawer-button').click(function() {
        closeDrawer();
    });

    $('.form-sortby input[type="checkbox"]').on("click",function(){
      let valor = $(this).val();
      
      $(`#SortBy option[value="${valor}"]`).prop('selected', true);
      $(`#FacetSortForm`).submit();
    }); 

});